import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useConfig } from '@xingternal/hops';
import { BodyCopy } from '@xingternal/typography';
import { IconEmail } from '@xingternal/icons';
import { ttt } from '@xingternal/malt-tracking';

import IconGoogle from '../IconGoogle';
import { PROP_CHANNEL } from '../../../../Components/PageviewTracker/PageviewTracker';

import {
  Button,
  ButtonsSection,
  Container,
  Content,
  Hero,
  Picture,
  InnerContainer,
} from './HeaderSectionControlOld.style';

import headerIllustrationJpg from '../images/header.jpg';
import headerIllustrationJpg2x from '../images/header2x.jpg';
import headerIllustrationWebp from '../images/header.webp';
import headerIllustrationWebp2x from '../images/header2x.webp';

const HEADER_ILLUSTRATION = {
  bitmapSrc: headerIllustrationJpg,
  bitmapSrc2x: headerIllustrationJpg2x,
  webpSrc: headerIllustrationWebp,
  webpSrc2x: headerIllustrationWebp2x,
};

const HeaderSectionControlOld = () => {
  const { externalUrl } = useConfig();

  const EmailButton = (
    <Button
      variant="primary"
      size="large"
      icon={IconEmail}
      href={`${externalUrl}/start/signup?sc_o=losp_sign_up_button_click&sc_o_PropActionOrigin=losp_sign_up_button_click_cta_1`}
    >
      <FormattedMessage
        id="WELCOME_STARTPAGE_HEADER_BUTTON"
        defaultMessage="Register for free"
      />
    </Button>
  );

  const GoogleButton = (
    <Button
      variant="secondary"
      size="large"
      icon={IconGoogle}
      href={`${externalUrl}/signup/oauth`}
      onClick={() => {
        ttt.pageview(
          PROP_CHANNEL,
          'wbm/Welcome/start/index/google',
          {},
          {
            PropTrackAction: 'lp_google_click',
          }
        );
      }}
    >
      <FormattedMessage
        id="WELCOME_STARTPAGE_PROCEED_WITH_GOOGLE_BUTTON"
        defaultMessage="Continue with Google"
      />
    </Button>
  );

  return (
    <Container>
      <InnerContainer>
        <Content>
          <Hero size="medium" sizeConfined="large" sizeWide="large">
            <FormattedMessage
              id="WELCOME_STARTPAGE_HEADER_TITLE"
              defaultMessage="It’s time to be yourself."
            />
          </Hero>
          <BodyCopy size="large">
            <FormattedMessage id="WELCOME_STARTPAGE_HEADER_SUBTITLE" />
          </BodyCopy>
          <ButtonsSection>
            {EmailButton}
            {GoogleButton}
          </ButtonsSection>
        </Content>
        <FormattedMessage id="WELCOME_STARTPAGE_HEADER_IMAGE_ALT">
          {text => (
            <Picture alt={text} loading="lazy" {...HEADER_ILLUSTRATION} />
          )}
        </FormattedMessage>
      </InnerContainer>
    </Container>
  );
};

export default HeaderSectionControlOld;
